import React from "react";
import "./MaatwerkHeader.css";
import { useTheme } from "@mui/material/styles";
import maatwerkLogo from "./logo-maatwerk.png";
import welocateLogo from "../../img/icons/welocate-bl.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GB, NL } from "country-flag-icons/react/3x2";

const MaatwerkHeader = ({ company }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { i18n } = useTranslation();
  // Media queries


  return (
    <React.Fragment>
        <div className="d-header-container">
          <div className="d-header-left">
            <img
              className="header-vwc-logo"
              src={company == "MAATWERK" ? maatwerkLogo : welocateLogo}
              alt="company-logo"
              onClick={() => navigate("/")}
            />
          </div>

          <div className="d-header-right">
            <div className="d-h-icons">
              <span
                className={`h-language ${i18n.language === "nl" ? "h-language-active" : ""}`}
                onClick={() => i18n.changeLanguage("nl")}
              >
                <NL style={{ width: "24px", height: "18px", borderRadius: "2px" }} />
                <span>NL</span>
              </span>
              <span
                className={`h-language ${i18n.language === "en" ? "h-language-active" : ""}`}
                onClick={() => i18n.changeLanguage("en")}
              >
                <GB style={{ width: "24px", height: "18px", borderRadius: "2px" }} />
                <span>EN</span>
              </span>
            </div>
          </div>
        </div>
    </React.Fragment>
  );
};

export default MaatwerkHeader;
